<template>
  <div class="inner-page message-page">
    <app-layout ovflowFlowMain="auto">
      <app-header slot="header">
        <header-right slot="right"></header-right>
      </app-header>
      <a-spin size="large" :spinning="isLoading">
      <div class="inner-page__main" slot="default">
        <div class="inner-page__main__bg message--bg">
          <breadcrumb :navList="false"></breadcrumb>
          <div class="inner-page__content">
            <div class="inner-page__content--header">
                <div class="inner-page__content--title">
                  <span class="title">消息</span>
                </div>
            </div>
            <div class="filter-button-list">
              <a-button v-for="(item, index) in filterButtonList" :key="index" @click="onFilterButtonClick(index)" :class="[isActiveButton === index ? 'active filter-button' : 'filter-button']" ghost>
                <a-badge class="custom-dot" v-if="index === 2" :dot="hasNewMessage">{{item}}</a-badge>
                <span v-else>{{item}}</span>
              </a-button>
            </div>
            <div class="message-list-wrap" v-if="messageList.length">
              <div class="message-list">
                <div class="message" v-for="(item, index) in messageList" :key="index">
                  <h6 :class="[item.is_read !== 1 ? 'title unread' : 'title']">{{item.content}}</h6>
                  <div class="widget">
                    <a-tag :color="item.is_read | getColor" @click="onReadStatusClick(item)">{{item.is_read | getText}}</a-tag>
                    <span class="time">{{item.created_at | getTime}}</span>
                  </div>
                </div>
              </div>
              <pagination :total="total" @pageChange="onPageChange" @pageSizeChange="onPageSizeChange"></pagination>
            </div>
            <empty v-else />
            <div></div>
          </div>
		  <breadcrumb :navList="navList"></breadcrumb>
        </div>
      </div>
      </a-spin>
    </app-layout>
  </div>
</template>

<script>
import HeaderRight from '../components/layout/header-right.vue'
import Breadcrumb from '../components/breadcrumb/breadcrumb.vue'
import Empty from '../components/empty/empty.vue'
import Pagination from '../components/pagination/pagination.vue'
import { message } from '@/api'
import eventHub from '@/event-hub'

export default {
  name: 'message',
  components: { HeaderRight, Breadcrumb, Empty, Pagination },
  data () {
    return {
      filterButtonList: ['全部', '已读消息', '未读消息'],
      isActiveButton: 0,
      hasNewMessage: true,
      navList: [
        {
          text: '返回首页'
        },
        {
          text: '消息'
        }
      ],
      messageList: [],
      total: 100,
      pageSize: 10,
      isLoading: true
    }
  },
  filters: {
    getColor (status) {
      return status === 1 ? '#9999A0' : '#CE2323'
    },
    getText (status) {
      return status === 1 ? '已读' : '未读'
    },
    getTime (time) {
      time = time || ''
      return time.substr(0, 10)
    }
  },
  created () {
    Promise.all([this.initData()]).then(() => {
    }).catch(() => {
      this.$message.error('请求数据失败')
    }).finally(() => {
      this.isLoading = false
    })
  },
  methods: {
    onReadStatusClick (item) {
      let { is_read, id } = item
      if (is_read === 1) {
        // 已读
        return
      }
      this.changeReadStatus(id)
    },

    changeReadStatus (id) {
      this.isLoading = true
      return message.noticeToRead({nid: id}).then(res => {
        let { status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.initData()
      })
    },

    onPageChange ({pageNumber}) {
      this.isLoading = true
      let params = {
        page: pageNumber,
        pageSize: this.pageSize
      }
      this.getMessageList(params)
    },

    onPageSizeChange ({current, pageSize}) {
      this.isLoading = true
      let params = {
        page: current,
        pageSize: pageSize
      }
      this.pageSize = pageSize
      this.getMessageList(params)
    },

    async initData () {
      await this.getMessageStatus()
      eventHub.$emit('updateMessageStatus', this.hasNewMessage)
      await this.getMessageList()
      return Promise.resolve()
    },
    async onFilterButtonClick (index) {
      this.isLoading = true
      this.isActiveButton = index
      await this.getMessageList()
    },

    getMessageList (params) {
      let temp = {
        page: 1,
        pageSize: this.pageSize,
        ...params,
        type: this.isActiveButton
      }
      return message.messageList(temp).then(res => {
        let { data: result, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }

        let { data = [], total } = result || {}

        if (this.isActiveButton === 1) {
          data.forEach((item, index) => {
            data[index].is_read = this.isActiveButton
          })
        }

        this.messageList = data
        this.total = total
        return data
      }).catch(() => {
        this.$message.error('请求数据失败')
      }).finally(() => {
        this.isLoading = false
      })
    },

    getMessageStatus () {
      let temp = {
        page: 1,
        pageSize: 10,
        type: 2
      }
      return message.messageList(temp).then(res => {
        let { data, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }

        let { total } = data || {}
        this.hasNewMessage = total > 0
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../assets/style/index";
  .message--bg{
    min-height: 874px;
  }
  .filter-button-list{
    border-bottom: 1px solid rgba(216, 216, 216, 0.1); /*no*/
    padding: 15px 0;
    margin-top: 15px;
    .filter-button{
      font-size: 14px;
      color: @dateColor;
      margin-right: 12px;
      border-color: @dateColor;
      border-radius: 14px;
      line-height: 28px;
      height: 28px;
      &.active{
        color: @hoverColor;
        border-color: @hoverColor;
      }
    }
  }
  .message-list{
    padding: 5px 0 80px 0;
    .message{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(216, 216, 216, 0.5); /*no*/
      padding: 25px 0;
    }
    .title{
      width: 938px;
      margin: 0 142px 0 0;
      color: @dateColor;
      font-size: 14px;
      line-height: 20px;
      &.unread{
        color: @textColor;
      }
    }
    .widget{
      flex: 1;
      display: flex;
      justify-content: space-between;
      .time{
        font-size: 14px;
        color: @dateColor;
      }
    }
  }
</style>

<style lang="less">
  .message-page{
    .custom-dot{
      .ant-badge-dot{
        width: 5px;
        height: 5px;
        box-shadow: none;
      }
    }
  }
  
</style>